import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { setPageTitle } from "../../app/features/DataSlice";
import { useGetProfileQuery } from "../../app/features/apiSlice";
import { Card, Col, Nav, Row, Tab } from "react-bootstrap";
import Loader from "../../components/Loader";
import Error from "../../components/Error";
import HeliorPlanDetails from "../../components/HeliorPlan/HeliorPlanDetails";
import HOneDetails from "../../components/HeliorOne/HOneDetails";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import "moment/locale/it";
import UserCard from "../../components/UserCard";
import PersonalDetails from "../../components/profileForm/PersonalDetails";
import BankDetails from "../../components/profileForm/BankDetails";
import ContactDetails from "../../components/profileForm/ContactDetails";
// import ClientInfo from "../../components/downloadPdf/ClientInfo";
import SelectLanguage from "../../components/profileForm/SelectLanguage";
import RequestNewKey from "../../components/profileForm/RequestNewKey";
import ResidentialDetails from "../../components/profileForm/ResidentialDetails";
import DomicileDetails from "../../components/profileForm/DomicileDetails";

const Profile = () => {
  const pageTitle = "profile";
  const { t } = useTranslation();
  const { lang } = useParams();
  lang === "it" ? moment.locale("it") : moment.locale("en");
  const dispatch = useDispatch();
  const sessionId = useRef(Date.now()).current;
  const { data, isLoading, isSuccess, isError, error, refetch } =
    useGetProfileQuery({
      sessionId,
    });

  useEffect(() => {
    dispatch(setPageTitle(t(`${pageTitle}`)));
    // eslint-disable-next-line
  }, [t]);

  return (
    <Row>
      {isLoading && <Loader />}
      {isError && <Error error={error} />}
      {isSuccess && (
        <>
          <Col lg={3}>
            <UserCard userData={data} commission={data?.commission} />
          </Col>
          <Col lg={9}>
            <Card bg="dark1 text-light h-100">
              <Card.Body>
                {data?.orgUser?.qualification && (
                  <div className="mb-3">
                    <p className="text-uppercase"><b className="text-gold">{t("careerLevel")}:</b> {data?.orgUser?.qualification}</p>
                  </div>
                )}
                <h6 className="text-uppercase">{t("myTeam")}</h6>
                <ul className="list-unstyled">
                  <li className="mb-2">
                    {t("direct")}: {data?.directCollaboratorCount}
                  </li>
                  <li className="mb-2">
                    {t("first2Levels")}: {data?.firstTwoLevelCollaboratorCount}
                  </li>
                  <li className="mb-2">
                    {t("totalTeam")}: {data?.totalTeamCount}
                  </li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col md="12" className="mt-3">
            <Card bg="dark1 text-light">
              <Card.Body>
                <Tab.Container defaultActiveKey="first">
                  <Row>
                    <Col sm={3}>
                      <Nav variant="pills" className="mb-2 flex-row flex-md-column flex-nowrap text-nowrap overflow-auto">
                        <Nav.Item>
                          <Nav.Link eventKey="first">
                            {t("personalDetails")}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="second">
                            {t("bankDetails")}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="third">
                            {t("contactDetails")}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="fourth">
                            {t("signup.residence")}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="fifth">
                            {t("domicile")}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="sixth">
                            {t("selectLanguge")}
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="seventh">
                            {t("requestNewKey")}
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </Col>
                    <Col sm={9}>
                      <Tab.Content>
                        <Tab.Pane eventKey="first">
                          <PersonalDetails data={data} refetch={refetch} isLoading={isLoading} error={error} />
                        </Tab.Pane>
                        <Tab.Pane eventKey="second">
                          <BankDetails refetch={refetch} />
                        </Tab.Pane>
                        <Tab.Pane eventKey="third">
                          <ContactDetails data={data} refetch={refetch} />
                        </Tab.Pane>
                        <Tab.Pane eventKey="fourth">
                          <ResidentialDetails data={data} refetch={refetch} />
                        </Tab.Pane>
                        <Tab.Pane eventKey="fifth">
                          <DomicileDetails data={data} refetch={refetch} />
                        </Tab.Pane>
                        <Tab.Pane eventKey="sixth">
                          <SelectLanguage data={data} refetch={refetch} />
                        </Tab.Pane>
                        <Tab.Pane eventKey="seventh">
                          <RequestNewKey />
                        </Tab.Pane>
                      </Tab.Content>
                    </Col>
                  </Row>
                </Tab.Container>
              </Card.Body>
            </Card>
          </Col>
          {data?.plan.length > 0 && (
            <Col className="mt-3" md="12">
              <HeliorPlanDetails plans={data?.plan} />
            </Col>
          )}
          {data?.heliorOne.length > 0 && (
            <Col className="mt-3" md="12">
              <HOneDetails plans={data?.heliorOne} />
            </Col>
          )}
        </>
      )}
    </Row>
  );
};

export default Profile;
